import { render, staticRenderFns } from "./survey-as-template.vue?vue&type=template&id=7cccc17d&scoped=true&"
import script from "./survey-as-template.vue?vue&type=script&lang=js&"
export * from "./survey-as-template.vue?vue&type=script&lang=js&"
import style0 from "./survey-as-template.vue?vue&type=style&index=0&id=7cccc17d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cccc17d",
  null
  
)

component.options.__file = "survey-as-template.vue"
export default component.exports